module.exports = __webpack_public_path__ + "img/google.2bd03d1.svg";